import { INavData } from '@coreui/angular';

export const navItems3: INavData[] = [
      {
        name: 'Dashboard',
        url: '/courier/dashboard',
        icon: 'icon-puzzle'
      },
      {
        name: 'MIS',
        url: '/courier/report/customermis',
        icon: 'icon-puzzle'
      },
      {
        name: 'Log Out',
        url: 'login',
        icon: 'icon-puzzle'
      }
  
  
];
